import luTableSelected from "./src/lu-table-selected";

luTableSelected.install = function(Vue) {
  Vue.component(luTableSelected.name, luTableSelected);
};

export default luTableSelected;
